<template>
<div>
  Описане для группы справочников.
  В этой группе ...
</div>
</template>

<script>
export default {
  name: 'nsi-group-note-view',
};
</script>

<style scoped>

</style>
